export default __webpack_public_path__ + "static/media/StuonB3.4cb9a998.png";